import {listActionsActionTypes} from '../constants/ActionTypes';

const initialState = {
  attributes: [],
};

const attributes = (state = initialState, action) => {
  switch (action.type) {
    case listActionsActionTypes.GET_ATTRIBUTES:
      return {
        ...state,
        attributes: action.attributes
      }
  }

  return state;
};

export default attributes;



// WEBPACK FOOTER //
// ./reducers/listActions.reducers.js